import React, { useEffect } from 'react'
import DesigneraddRole from './DesigneraddRole'

const ApproverRegister = (props) => {
  
useEffect(()=>
{
  console.log("approverfile")
    const nextapicall=async ()=>
{
  
  let pesponse = await fetch(
    `http://localhost:8080/auth/admin/realms/forms-flow-ai/users`,
    {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
          'Content-Type': 'application/json',
           "Host": "localhost:8080",
           'Content-Length': JSON.stringify({
            enabled: true,
            attributes: {},
            groups: ["/formsflow/formsflow-reviewer/approver"],
            username: props.submissiondata.data.approvername,
            credentials: [{
                type: "password",
                value: "changeme",
                  temporary: "true"
              }],
            emailVerified: "",
            email: props.submissiondata.data.approvername,
          }).length,

          Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,
        

        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body:JSON.stringify({
        enabled: true,
        attributes: {},
        groups: ["/formsflow/formsflow-reviewer/approver"],
        username: props.submissiondata.data.approveremail,
        emailVerified: "",
        credentials: [{
            type: "password",
            value: "changeme",
              temporary: "true"
          }],
        email: props.submissiondata.data.approveremail,
      }) // body data type must match "Content-Type" header
    }
  )
}

nextapicall();
},[])


  return (
 <DesigneraddRole/>
  )
}

export default ApproverRegister;